import { Injectable } from '@angular/core';
import { IAssignRevokePermissionsClient } from './i-assign-revoke-permissions.client';
import { Observable, of } from 'rxjs';
import { IAssignRevokePermissionsRequest } from '../dtos/requests/assign-revoke-permissions.request';
import { CollectionApiClient } from '../../../../core/data-access/http-client/clients/api-client-service';
import { HttpClient } from '@angular/common/http';
import { IPermissionGroup } from '../models/permission-group.model';
import { UserManagementCollections } from '../../../common/collections/user-management.collections';

@Injectable({
    providedIn: 'root'
})
export class AssignRevokePermissionsClient implements IAssignRevokePermissionsClient {
    private collectionApiClient: CollectionApiClient;

    constructor(protected http: HttpClient) {
        this.collectionApiClient = CollectionApiClient.create(UserManagementCollections.Permissions, http);
    }

    permissionGroups(): Observable<IPermissionGroup[]> {
        return this.collectionApiClient.get();
    }

    assignedPermissionGroups(endpoint: string): Observable<IPermissionGroup[]> {
        return this.collectionApiClient.get({ collectionName: endpoint });
    }

    assign(endpoint: string, body: IAssignRevokePermissionsRequest): Observable<void> {
        return this.collectionApiClient.post({ collectionName: endpoint, body });
    }

    revoke(endpoint: string, body: IAssignRevokePermissionsRequest): Observable<void> {
        return this.collectionApiClient.delete({ collectionName: endpoint, body });
    }
}
